<template>
    <b-form-group
            v-if="dataIsVisible"
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <label v-if="dataReadOnly">{{dataValue}}</label>
        <VueTimepicker v-else v-model="dataValue" :minute-interval="minuteInterval" format="HH:mm"></VueTimepicker>
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'

  export default {
      name: 'InputTime',
      components: {
          VueTimepicker
      },
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String,
              value: ''
          },
          minuteInterval: {
              type: Number,
              value: 5
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          _isVisible: {
              type: Boolean,
              default: true
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          this.dataValue = this.value
          this.dataReadOnly = this.readOnly
      },
      data: () => {
          return {
              dataValue: {},
              dataReadOnly: false,
              dataIsVisible: true
          }
      },
      computed: {
          isReadOnly: {
              set(val) {
                  this.dataReadOnly = val
              },
              get() {
                  return this.dataReadOnly
              }
          },
          isVisible: {
              get() {
                  return this.dataIsVisible
              },
              set(val) {
                  this.dataIsVisible = val
              }
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>